import { ValueOf } from '../../utilities/types';

const panelModes = {
  FLOATING: 'floating',
  DOCKED: 'docked',
} as const;

export type PanelMode = ValueOf<typeof panelModes>;

export default panelModes;
